module.exports = __webpack_public_path__ + "img/genre_hiphop_rap.6ed071ce.png";